import { appConfig } from '../../../../appConfig';
import { appRoutes } from '../../../../routes';
import { trimEnd } from '../../../common/utils/stringUtils';

const productBaseUrl = trimEnd(appConfig.coopSettings.ecommerce.productBaseUrl, '/');
export const ecommerceRoutes = {
    ecommerceBase: `${appConfig.coopSettings.ecommerce.url}` as const,
    orderComplete: `${appRoutes.ecommerce.checkout.orderComplete.url}` as const,
    productOrSection: `${productBaseUrl}/:section1?/:section2?/:section3?/:product?` as const,
};
